const enum ReleaseFlag {
  INFLIGHT = 'eureka0',
  MANAGE_SINGLE_SIM_PROFILE_SWAP = 'manage_single_profile_swap',
  HIDE_TOWER_LOCATIONS = 'tower_location_hidden',
  EMBED_PREFLIGHT_OVERVIEW = 'embed_preflight_overview',
  FEATURE_DATA_USAGE_ALERTS = 'feature_data_usage_alerts',
  FEATURE_SPACEBRIDGE_TUNNELING = 'feature_spacebridge_tunneling',
  FEATURE_HOLOGRAM_CLOUD_MESSAGING = 'feature_hologram_cloud_messaging',
  FEATURE_WEBHOOKS = 'feature_webhooks',
  FEATURE_ROUTES = 'routes',
  FEATURE_PREDEPLOYMENT = 'feature_predeployment',
}

export default ReleaseFlag;
